/**
 * Gender options
 *
 * Needs to be a string enum, as only string enums can be iterated over using `Object.values`
 */
export enum Gender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  NO_DATA = 'NO_DATA'
}
